/**
 * Created by zhengyf on 2017/9/26.
 *
 * params:
 *  givenData: {list: [], hid: ''} 产品列表
 *  selectBoxWidth: number 图片容器宽度
 *  loading: boolean
 *  onUpdata: function 根据类目切换产品列表
 */

;(function () {
    selectProductCtrl.$inject = ['$timeout'];
    angular
        .module('DSSXAPP')
        .component('selectProduct', {
            template:'<div class="international-home-selected-products s-p-wrap"><div class="s-p-title c-b"><h2 class="f-l"><a href="javascript:;">SELECTED PRODUCTS</a></h2><div class="sub-title f-l">Real Activity Data from China Customs</div><div class="label"></div></div><div class="s-p-content"><div class="actions f-l"><ul class="tabs"><li class="tab-item" ng-repeat="item in vm.d.tabsList track by $index" ng-class="{\'selected\': item.selected}" ng-click="vm.f.updataProductList(item.title, $index)"><div class="img-wrap" ng-class="{\'selected\': item.selected}"><div class="img-box"><img ng-src="{{item.img}}"></div></div><div class="tab-title"><div class="tab-title-box" ng-class="{\'selected\': item.selected}"><div class="util-ellipsis" ng-class="{\'view-more\': $index === 4}" ng-bind="item.title"></div></div></div></li></ul></div><div class="panels"><div class="panel-item"><div class="product-wrapper"><div class="product-list-box" id="product-list-box"><div class="product-list c-b" ng-style="vm.d.pListLeft"><div class="product-col" ng-repeat="pcol in vm.d.productList track by $index" ng-class="{\'first\': $index === 0}" ng-show="vm.d.productList.length !== 0"><div class="product-row" ng-repeat="p in pcol track by $index"><a ng-href="{{p.prodDetailUrl}}" target="_blank" ng-class="{\'no-last\': p.number === 0}" ng-show="p"><div class="img-box"><img ng-src="{{p.img}}"></div><div class="info"><div class="blank-wrap"></div><p ng-bind="p.productName" ng-attr-title="{{p.productName}}" class="util-ellipsis"></p><p class="price util-ellipsis" ng-show="p.price"><span>US $</span> <span ng-bind="p.price"></span></p><p class="transaction util-ellipsis">1 Transaction</p><p><i class="iconfont icon-similar-product"></i> <span>Similar Products</span> <i class="iconfont icon-more"></i></p></div></a></div></div></div><div class="tip" ng-show="vm.d.productList.length === 0">暂无商品</div></div><i class="iconfont icon-back i-back" ng-click="vm.f.setPListLeft(\'prev\')" ng-class="{\'able-click\': vm.isAbleClick.prev}"></i> <i class="iconfont icon-more i-more" ng-click="vm.f.setPListLeft(\'next\')" ng-class="{\'able-click\': vm.isAbleClick.next}"></i><div class="loading-wrap" ng-show="vm.d.loading"><img src="images/common/loading.gif"></div></div><ul>SELECTED PRODUCTS</ul></div></div></div></div>',
            bindings: {
                givenData: '<',
                selectBoxWidth: '<',
                loading: '<',
                onUpdata: '&'
            },
            controllerAs: 'vm',
            controller: selectProductCtrl
        });

    function selectProductCtrl($timeout) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.d = {
            tabsList: [
                {
                    img: 'images/aliIndex/s-p1.jpg',
                    title: 'Apparel'
                },
                {
                    img: 'images/aliIndex/s-p2.jpg',
                    title: 'Consumer Electronics'
                },
                {
                    img: 'images/aliIndex/s-p3.jpg',
                    title: 'Home & Garden'
                },
                {
                    img: 'images/aliIndex/s-p4.jpg',
                    title: 'Luggage, Bags & Cases'
                },
                {
                    img: 'images/aliIndex/omitted.png',
                    title: 'View more'
                }
            ],
            productList: [
                [
                    {
                        img: 'images/aliIndex/s111.webp',
                        productName: 'women dress',
                        price: '9.9', // 有些有价格有些没价格
                        number: 0
                    },
                    {
                        img: 'images/aliIndex/s111.webp',
                        productName: 'women dress',
                        price: '9.9',
                        number: 1
                    }
                ]
            ],
            pListLeft: {
                width: '',
                transform: 'translateX(0)'
            },
            oldProductList: [],
            loading: false,
            hid: ''
        };

        vm.isAbleClick = {
            prev: false,
            next: false
        };

        vm.f = {
            setPListLeft: setPListLeft,
            getToken: DSSX.util.getToken,
            updataProductList: updataProductList
        };

        vm.left = 0;
        vm.totalLeft = 0;

        var num = 3;
        var COL_WIDTH = 357;
        var mistakeWidth = 85;

        // ===============function=====================

        function onInit() {
            console.log('[selected products init: ]');
            initSelectedTab(0);
            initPListWidth();
        }

        function bindingsOnChanges(changes) {

            if (changes.givenData) {
                vm.d.oldProductList = angular.copy(vm.givenData.list);
                vm.d.hid = vm.givenData.hid;
                vm.d.productList = handleGivenData(vm.givenData.list);
                initPListWidth();
                resetTranslateX();
            }

            if (changes.selectBoxWidth) {
                var width = angular.copy(vm.selectBoxWidth); //
                num = Math.floor(width / COL_WIDTH);
                mistakeWidth = width - num * COL_WIDTH;
                initPListWidth();
            }

            if (changes.loading) {
                vm.d.loading = angular.copy(vm.loading);
            }
        }

        /**
         * 设置选中左侧哪个标签栏
         * @param index
         */
        function initSelectedTab(index) {
            var tabList = vm.d.tabsList;
            for (var i = 0; i < tabList.length; i++) {
                tabList[i].selected = false;
            }
            tabList[index].selected = true;
        }

        /**
         * 处理需要显示的产品列表
         * @param list
         * @returns {Array}
         */
        function handleGivenData(list) { //[{}]

            var result = [];
            var handleFirst = [];
            for (var i = 0; i < list.length; i += 1) {
                var defaultObj = {
                    quantityPrice: {},
                    priceSetting: 'uniform'
                }
                var tradeInfo = list[i].tradeInfo || defaultObj;

                var price = countPrice(tradeInfo.quantityPrice, tradeInfo.priceSetting);

                handleFirst.push({
                    img: DSSX.util.safe(list[i], 'imgs.0.url', '') + '/small',
                    productName: list[i].productName,
                    price: price.price, // 有些有价格有些没价格
                    prodDetailUrl: DSSX.util.getNeedCountClickPageUrl(list[i].id, vm.d.hid, 'HOME_PAGE', 'prod')
                    // number: i % 2
                });
            }

            for (var j = 0; j < handleFirst.length; j += 2) {
                result.push([handleFirst[j],handleFirst[j+1]]);
            }
            return result;
        }

        /**
         * 价格换算
         * @param price {'起订量': '价格1-价格2'}
         * @param unit 单位
         * @param priceSetting 价格类型
         * @returns {{price: number, unit: string}}
         */
        function countPrice(price, priceSetting) {
            var result = {
                price: 0,
                unit: ''
            };
            var keys = [];
            // result.unit = unit === '计量单位' || '-' ? 'Piece' : unit.split('/')[0];

            if(isEmptyObject(price)) {
                result.price = '';
            } else {
                if (priceSetting === 'fob') {
                    for (t in price) {
                        var p = price[t];
                        if (p === '-') {
                            p = '';
                        }
                        result.price = p.split('-')[0];
                    }
                } else {
                    for (key in price) {
                        keys.push(key);
                    }
                    result.price = price[keys[keys.length - 1]];
                }
            }
            return result;
        }

        function resetTranslateX() {
            vm.left = 0;
            vm.d.pListLeft.transform = 'translateX(0px)';
        }


        /**
         * 初始化productList的width
         */
        function initPListWidth() {
            var pLength = vm.d.productList.length;
            var width = pLength * COL_WIDTH;
            vm.d.pListLeft.width = width + 'px';
            vm.totalLeft = width - vm.selectBoxWidth;
            if (width < vm.selectBoxWidth) {
                setBtnStatus(false, false);
            } else {
                setBtnStatus(false, true);
            }
        }

        /**
         * 设置banner图left
         * @param option
         */
        function setPListLeft(option) {
            if (option === 'next' && !vm.isAbleClick.next) {
                return;
            }

            if (option === 'prev' && !vm.isAbleClick.prev) {
                return;
            }

            setBtnStatus(true, true);

            vm.left = option === 'next' ? (vm.left - COL_WIDTH * num) : (vm.left + COL_WIDTH * num);
            if (vm.left > 0) {
                vm.left = 0;
                setBtnStatus(false, true);
            }
            if (-vm.left > vm.totalLeft) {
                vm.left = 0 - vm.totalLeft;
                setBtnStatus(true, false);
            }
            vm.d.pListLeft.transform = 'translateX(' + vm.left + 'px)';
        }

        function setBtnStatus(prev, next) {
            vm.isAbleClick.prev = prev;
            vm.isAbleClick.next = next;
        }

        /**
         * 更换不同类别产品
         * @param title
         */
        function updataProductList(title, index) {
            if (title === 'View more') {
                return;
            }
            initSelectedTab(index);
            vm.onUpdata({cate: title.trim()});
        }

        function isEmptyObject(e) {
            var t;
            for (t in e) {
                return false;
            }
            return true;
        }

    }


})();